import { c as _c } from "react/compiler-runtime";
import StarRating from '@/components/modules/rating/StarRating';
import RatingCount from './RatingCount';
import RatingNumber from './RatingNumber';
const RatingBadge = t0 => {
    const $ = _c(10);
    const { rating: t1, count: t2, className } = t0;
    const rating = t1 === undefined ? 0 : t1;
    const count = t2 === undefined ? 0 : t2;
    const computedClassName = `flex flex-col items-center justify-center flex-shrink-0 rounded-full w-28 h-28 bg-white border border-gray-100 ${className}`;
    let t3;
    let t4;
    if ($[0] !== rating) {
        t3 = <RatingNumber rating={rating} className="text-2xl mb-1"/>;
        t4 = <StarRating rating={rating}/>;
        $[0] = rating;
        $[1] = t3;
        $[2] = t4;
    }
    else {
        t3 = $[1];
        t4 = $[2];
    }
    let t5;
    if ($[3] !== count) {
        t5 = <RatingCount count={count} className="text-sm mt-2.5"/>;
        $[3] = count;
        $[4] = t5;
    }
    else {
        t5 = $[4];
    }
    let t6;
    if ($[5] !== computedClassName || $[6] !== t3 || $[7] !== t4 || $[8] !== t5) {
        t6 = <div className={computedClassName}>{t3}{t4}{t5}</div>;
        $[5] = computedClassName;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
    }
    else {
        t6 = $[9];
    }
    return t6;
};
export default RatingBadge;
